
import ToDoList from './ToDoList';

function App() {
  return (
    <div className="bg-myBg">
      <ToDoList/>
    </div>
  );
}

export default App;
